<template>
    <div class="printers-setup">
        <div class="step-title">{{ $t('get_started.printers_setup_title') }}</div>
        <!-- <div class="step-description">{{ $t('get_started.printers_setup_description') }}</div> -->

        <component
            :is="isAllegra ? 'AllegraPrintersSettings' : 'AriaPrintersSettings'"
            v-if="printers.loaded"
            ref="printersSettings"
            class="pb-3 mt-6"
            :predefined-printers="printers.predefined"
            :server-printers="printers.serverPrintConfig"
            :get-started="true"
        />

        <div class="footer">
            <v-btn
                class="flex-1"
                color="primary"
                depressed
                :disabled="busy"
                :loading="busy"
                @click="savePrintSettings()"
            >
                {{ $t('general.next') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import * as mutationTypes from '@/store/mutationTypes'
import ApiService from '@/services/ApiService'
import AriaPrintersSettings from '@/views/aria/PrintersSettings';
import AllegraPrintersSettings from '@/views/allegra/PrintersSettings';

export default {
    components: {
        AriaPrintersSettings,
        AllegraPrintersSettings
    },

    created() {
        this.loadPrintSettings();
    },

    props: {
        active: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            busy: false,

            printers: {
                loaded: false,
                predefined: [],
                serverPrintConfig: null
            },
        };
    },

    methods: {

        /**
         * Load Print Settings
         */
        loadPrintSettings() {
            ApiService.get('/getstarted/printers').then(response => {
                this.printers.loaded = true;
                this.printers.predefined = response.data.printers;
                this.printers.serverPrintConfig = response.data.printConfig;
            });
        },

        /**
         * Save Print Settings
         */
        savePrintSettings() {
            if(!this.$refs.printersSettings) return

            this.busy = true;

            this.$refs.printersSettings.savePrinters().then(() => {
                ApiService.post('/getstarted/printers', {}).then(response => {
                    this.$store.commit(mutationTypes.SET_TENANT, { tenant: response.data.tenant });
                    this.busy = false;
                    this.$emit('finish')
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.printers-setup {
    .step-title {
        margin-bottom: 10px;
        font-size: 20px;
    }

    .step-description {
        margin-bottom: 30px;
        font-size: 14px;
        color: #8f9095;
    }

    .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
}
</style>
